// Components
import InputBase from '@mui/material/InputBase';

// Styles
import { styled } from '@mui/material/styles';

const MUISelectStyle = styled(InputBase)(({ theme }) => ({
  '& label': {
    color: '#002747',
    backgroundColor: '#ffffff',
  },
  'label + &': {
    marginTop: theme.spacing(2),
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #758893',
    fontSize: 16,
    padding: '14px 26px 14px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      borderColor: '#9b722a',
    },
    '&:focus': {
      borderRadius: 4,
      borderColor: '#9b722a',
    },
  },
}));

export default MUISelectStyle;
